export default {
  computed: {
    basicInfoFields() {
      return [
        {
          key: 'sales_name',
          responseKey: 'sales_name',
          name: 'sales_name',
          placeholder: this.$t('salesOrder.placeholder.salesName'),
          type: 'taggable-select-input',
          label: this.$t('salesOrder.field.salesName'),
          labelKey: 'value',
          validation: [['bail'], ['optional'], ['min', 2], ['max', 144]],
          optionLabelFn: (item) => item.item.value,
        },
        {
          key: 'customer_name',
          responseKey: 'customer_name',
          name: 'customer_name',
          placeholder: this.$t('salesOrder.placeholder.customerName'),
          type: 'taggable-select-input',
          label: this.$t('salesOrder.field.customerName'),
          labelKey: 'value',
          validation: [['bail'], ['optional'], ['min', 2], ['max', 144]],
          optionLabelFn: (item) => item.item.value,
        },
        {
          key: 'reference_number',
          responseKey: 'reference_number',
          name: 'reference_number',
          type: 'text',
          label: this.$t('salesOrder.field.referenceNumber'),
          placeholder: this.$t('salesOrder.placeholder.referenceNumber'),
        },
        {
          key: 'total_weight',
          responseKey: 'total_weight',
          name: 'total_weight',
          type: 'text',
          _type: 'number',
          label: this.$t('salesOrder.field.totalWeight'),
          validation: [['bail'], ['optional'], ['number']],
          placeholder: this.$t('salesOrder.placeholder.totalWeight'),
          suffix: 'Kg',
        },
        {
          key: 'total_volume',
          responseKey: 'total_volume',
          name: 'total_volume',
          type: 'text',
          _type: 'number',
          label: this.$t('salesOrder.field.totalVolume'),
          validation: [['bail'], ['optional'], ['number']],
          placeholder: this.$t('salesOrder.placeholder.totalVolume'),
          suffix: 'Cbm',
        },
        {
          key: 'total_price',
          responseKey: 'total_price',
          name: 'total_price',
          type: 'text',
          _type: 'number',
          label: this.$t('salesOrder.field.totalPrice'),
          validation: [
            ['bail'],
            ['optional'],
            ['min', 1, 'value'],
            ['max', 1000000000000, 'value'],
          ],
          placeholder: this.$t('salesOrder.placeholder.totalPrice'),
          prefix: 'Rp',
        },
        {
          key: 'target_picked_on',
          responseKey: 'target.picked_on',
          name: 'target_picked_on',
          label: this.$t('salesOrder.field.targetPickedOn'),
          placeholder: this.$t('salesOrder.placeholder.selectDate'),
          type: 'date-picker',
          datepickerType: 'datetime',
          valueType: 'YYYY-MM-DDTHH:mm:ssZ',
          validation: [['bail'], ['optional']],
          format: 'DD MMM YYYY HH:mm',
          showSecond: false,
          confirm: true,
          confirmText: 'Terapkan',
          lang: {
            formatLocale: {
              weekdaysMin: ['Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab', 'Min'],
            },
          },
        },
        {
          key: 'target_delivered_on',
          responseKey: 'target.delivered_on',
          name: 'target_delivered_on',
          label: this.$t('salesOrder.field.targetDeliveredOn'),
          placeholder: this.$t('salesOrder.placeholder.selectDate'),
          type: 'date-picker',
          datepickerType: 'datetime',
          valueType: 'YYYY-MM-DDTHH:mm:ssZ',
          validation: [['bail'], ['optional']],
          format: 'DD MMM YYYY HH:mm',
          showSecond: false,
          confirm: true,
          confirmText: 'Terapkan',
          lang: {
            formatLocale: {
              weekdaysMin: ['Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab', 'Min'],
            },
          },
        },
      ]
    },

    customerInfoFields() {
      return [
        {
          key: 'sender_name',
          responseKey: 'sender.name',
          name: 'sender_name',
          placeholder: this.$t('salesOrder.placeholder.senderName'),
          type: 'taggable-select-input',
          label: this.$t('salesOrder.field.senderName'),
          labelKey: 'value',
          validation: [['bail'], ['optional'], ['min', 2], ['max', 144]],
          optionLabelFn: (item) => item.item.value,
          offsetMd: 7,
        },
        {
          key: 'sender_phone_number',
          responseKey: 'sender.phone_number',
          name: 'sender_phone_number',
          placeholder: this.$t('salesOrder.placeholder.senderPhoneNumber'),
          type: 'taggable-select-input',
          label: this.$t('salesOrder.field.senderPhoneNumber'),
          labelKey: 'value',
          validation: [['bail'], ['optional'], ['min', 2, 'length'], ['max', 144, 'length']],
          optionLabelFn: (item) => item.item.value,
        },
        {
          key: 'recipient_name',
          responseKey: 'recipient.name',
          name: 'recipient_name',
          placeholder: this.$t('salesOrder.placeholder.recipientName'),
          type: 'taggable-select-input',
          label: this.$t('salesOrder.field.recipientName'),
          labelKey: 'value',
          validation: [['bail'], ['optional'], ['min', 2], ['max', 144]],
          optionLabelFn: (item) => item.item.value,
        },
        {
          key: 'recipient_phone_number',
          responseKey: 'recipient.phone_number',
          name: 'recipient_phone_number',
          placeholder: this.$t('salesOrder.placeholder.recipientPhoneNumber'),
          type: 'taggable-select-input',
          label: this.$t('salesOrder.field.recipientPhoneNumber'),
          labelKey: 'value',
          validation: [['bail'], ['optional'], ['min', 2, 'length'], ['max', 144, 'length']],
          optionLabelFn: (item) => item.item.value,
        },
      ]
    },

    otherInfoField() {
      return {
        key: 'note',
        responseKey: 'note',
        name: 'note',
        type: 'textarea',
        label: this.$t('salesOrder.field.note'),
        validation: [['bail'], ['optional'], ['min', 1], ['max', 255]],
        placeholder: this.$t('salesOrder.placeholder.note'),
      }
    },

    locationField() {
      return {
        key: 'locations',
        responseKey: 'locations',
        placeholder: this.$t('salesOrder.placeholder.locations'),
        type: 'taggable-select-input',
        labelColumn: this.$t('salesOrder.field.locations'),
        labelKey: 'value',
        validationName: this.$t('salesOrder.field.locations'),
        validation: [['bail'], ['required'], ['min', 3], ['max', 255]],
        optionLabelFn: (item) => item.item.value,
        'validation-behavior': 'live',
        'error-behavior': 'value',
      }
    },
  },
}
